export enum ListQueryParam {
  Filter = 'filter',
  Size = 'size',
  Page = 'page',
  Active = 'active',
  Approved = 'approved',
  ApprovalStatus = 'approvalStatus',
  Types = 'types',
  Type = 'type',
  Sort = 'sort',
  Name = 'name',
  Status = 'status',
  MaterialNumber = 'materialNumber',
  PlantId = 'plantId',
  Delay = 'delay',
  Limit = 'limit',
  ProfileId = 'profileId',
  ProfileName = 'profileName',
  Application = 'application',
  BoschMaterialNumbers = 'boschMaterialNumber',
  CustomerMaterialNumbers = 'customerMaterialNumber',
  BoschOrderNumbers = 'boschOrderNumber',
  CustomerOrderNumbers = 'customerOrderNumber',
  HandlingUnitIds = 'huId',
  DateTimeRange = 'dateTimeRange',
  PartnerTypeFilter = 'partnerType',
  TransactionDateTime = 'transactionDateTime',
  CarrierId = 'carrierId',
  CarrierTO = 'carrierTO',
  LoadNumber = 'loadNumber',
  TransportOrderNumber = 'transportOrderNumber',
  ReportTypes = 'reportTypes',
  ReportStatuses = 'reportStatuses',
  ActivityType = 'uliType',
  HasSapClientViews = 'hasSapClientViews',
  TransportReferences = 'transportReferences',
  TrailerPlateFilter = 'trailerPlateFilter',
  LoadNumberFilter = 'loadNumberFilter',
}
